"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.correctionRegisterQuerySchema = exports.lookupCorrectionReceiptQuerySchema = void 0;
/**
 * Request contracts for the CORRECTION TAB under Cash Counter (desk, 2026-10-12):
 *
 *   "Need Correction tab under Cash Counter page ... user will enter receipt number and select the parameter what should
 *    be edit and send for approval ... need register also to track date wise, receipt wise, op number wise ... request
 *    should give by user their own created document. Other user created document can not be edited by another user."
 *
 * Two reads, both for the SIGNED-IN user only:
 *
 *   lookup    the receipt number the clerk typed -> the receipt, if it is theirs;
 *   register  the correction requests THEY entered, filtered by date / receipt number / OP number.
 *
 * The write side is unchanged: the request itself still goes through the payment-method and receipt correction
 * endpoints, which now also refuse a receipt the caller did not create.
 */
const zod_1 = require("zod");
const financial_payment_correction_request_1 = require("./financial-payment-correction.request");
/** `''` from an empty form box means "no filter", never "match nothing". */
const optionalText = (max) => zod_1.z.preprocess((value) => (typeof value === 'string' && value.trim() === '' ? undefined : value), zod_1.z.string().trim().max(max).optional());
/** A calendar day as the desk reads it, `YYYY-MM-DD` (hospital local day, not a UTC instant). */
const calendarDay = zod_1.z.preprocess((value) => (typeof value === 'string' && value.trim() === '' ? undefined : value), zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Use a date as YYYY-MM-DD').optional());
exports.lookupCorrectionReceiptQuerySchema = zod_1.z.object({
    /** The number printed on the receipt — an OP receipt (invoice) number or an IP advance receipt number. */
    receiptNumber: zod_1.z.string().trim().min(1, 'Enter the receipt number').max(50),
});
exports.correctionRegisterQuerySchema = zod_1.z.object({
    /** First and last day the request was ENTERED (inclusive). */
    fromDate: calendarDay,
    toDate: calendarDay,
    /** Part of a receipt number — the register is searched by what is read off the paper. */
    receiptNumber: optionalText(50),
    /** Part of an OP number (UHID). */
    opNumber: optionalText(30),
    status: financial_payment_correction_request_1.paymentCorrectionStatusEnum.optional(),
    limit: zod_1.z.coerce.number().int().positive().max(500).default(200),
});
//# sourceMappingURL=financial-correction-register.request.js.map